import service from '@/plugins/service'

const adminApi = {}

adminApi.listUserGroup = () => {
  return service({
    url: '/admin/user_group/list',
    method: 'get'
  })
}

adminApi.searchUserGroup = (id) => {
  return service({
    url: `/admin/user_group/search/${id}`,
    method: 'get'
  })
}

export default adminApi
